<div class="popup-events-container">
    <div class="header">
        <h4>{{data.title}}</h4>
        <img (click)="closedialogClick()" src="assets/rule/close-dialog.svg">
    </div>
    <div class="body">

        <div class="body-row-1">

            <div class="body-row-1-row-1">
                <div class="body-row-1-col-1">
                    <span class="event-status-key">
                        Status:
                    </span>
                    <span class="event-status-value">
                        {{eventView.status_disp}}
                    </span>
                </div>
                <div class="body-row-1-col-2">
                    <span class="event-status-key">
                        State:
                    </span>
                    <span class="event-status-value">
                        {{eventView.alertstate_disp}}
                    </span>
                </div>
            </div>
        </div>
        <div class="body-row-2">

            <div class="body-row-2-col-1" *ngIf="this.data.mode == 'Alerts'">
                <span class="checkbox-container">
                    <!-- <input type="checkbox"
                        (click)="alertvarservice.updateSelectedEventAlerts(alertvarservice.AlertEvents[alertKey],alertKey,eventIndex,$event)"
                        [checked]="alertvarservice.isAlertInCurrentPageSlected(alertvarservice.eventspagenumber,eventIndex,alertvarservice.eventsItemperpage.value,alertKey)"
                        [disabled]="alertvarservice.isAlertInCurrentPageSlected(alertvarservice.eventspagenumber,eventIndex,alertvarservice.eventsItemperpage.value,alertKey)"
                        > -->
                        <input type="checkbox"
                        (click)="alertvarservice.updateSelectedEventAlerts(alertvarservice.AlertEvents[selectedEventKey],selectedEventKey,eventIndex,$event)"
                        [checked]="alertvarservice.isAlertInCurrentPageSlected(alertvarservice.eventspagenumber,eventIndex,alertvarservice.eventsItemperpage.value,selectedEventKey)"
                        >
                    <span class="checkmark"></span>
                </span> Add to Selection
            </div>
            <div class="body-row-2-col-1" *ngIf="this.data.mode != 'Alerts'">
                <span class="checkbox-container">
                    <input type="checkbox" [checked]="eventView.isSelected" (click)="clickAction()">
                    <span class="checkmark"></span>
                </span> Add to Selection
            </div>
            <div class="body-row-2-col-2">
                <button (click)="paginationTable_click(-1)" [ngClass]="eventIndex+1 | disableAction:numberofevents:-1">
                    <img src="assets/alerts/left-arrow.svg">
                </button>
                <p>{{eventIndex+1}} of {{numberofevents}}</p>
                <button (click)="paginationTable_click(1)">
                    <img src="assets/alerts/right-arrow.svg" [ngClass]="eventIndex+1 | disableAction:numberofevents:1">
                </button>
            </div>

        </div>
        <div class="body-row-3">
            <div class="body-row-3-1">
                <ng-container *ngFor="let event of eventView.eventdetails|keyvalue:originalOrder">
                    <div class="alertList">
                        <ng-container *ngIf="event.value != '--NA--'">
                            <span class="event-key">{{event.key}}</span>
                            <span class="event-value" [tooltip]="event.value">{{event.value}}</span>
                            <!-- <span class="event-value" [tooltip]="event.value"
                                *ngIf="event.value.length > 35">{{event.value|limitString:35}}</span> -->
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>

    </div>
</div>




<!-- 
<div class="popup-events-container">
    <div class="header">
        <h4>{{data.title}}</h4>
        <img (click)="closedialogClick()" src="assets/rule/close-dialog.svg">
    </div>
    <div class="body">

        <div class="body-row-1">
            <div class="body-row-1-col-1">
                <span class="checkbox-container" >
                    <input type="checkbox" [checked]="eventView.isSelected" (click)="clickAction()">
                    <span class="checkmark"></span>
                </span>
            </div>
            <div class="body-row-1-col-2">
                <span>
                    {{eventView.status}}
                </span>
            </div>
            <div class="body-row-1-col-3">
                <span>
                    {{eventView.alertstate}}
                </span>
            </div>
            <div class="body-row-1-col-4">
                <button (click)="paginationTable_click(-1)" [ngClass]="eventIndex+1 | disableAction:numberofevents:-1">
                    <img src="assets/alerts/left-arrow.svg">
                </button>
                <p>{{eventIndex+1}} of {{numberofevents}}</p>
                <button (click)="paginationTable_click(1)">
                    <img src="assets/alerts/right-arrow.svg" [ngClass]="eventIndex+1 | disableAction:numberofevents:1">
                </button>
            </div>

            
        </div>
        <div class="body-row-2">
            <div class="body-row-2-1">
                <ng-container *ngFor="let event of eventView.eventdetails|keyvalue:originalOrder">
                    <div class="alertList">
                        <span class="event-key">{{event.key}}</span>
                        <span class="event-value">{{event.value}}</span>
                    </div>
                </ng-container>
            </div>
        </div>

    </div>
</div> -->